import { render } from "./StationSimpleInfo.vue?vue&type=template&id=93368d76&scoped=true"
import script from "./StationSimpleInfo.vue?vue&type=script&lang=js"
export * from "./StationSimpleInfo.vue?vue&type=script&lang=js"

import "./StationSimpleInfo.vue?vue&type=style&index=0&id=93368d76&lang=scss&scoped=true"

import exportComponent from "/root/workspace/fpcs-h5_ORUL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-93368d76"]])

export default __exports__